import React, { useMemo } from 'react';
import { useInfoAggiuntivaBilanciata, useInfoTipo } from 'features/sport/hooks';

import { KeyManagerSport } from 'features/sport';
import { ScommesseEsitoSkeleton } from 'components/scommesseEsitoSkeleton';
import { ScommesseTipoProps } from '../types';
import { calculateBoxNumber } from 'components/scommesseTipo';
import { esitoTrKey } from '..';

export const Skeleton = ({ scommessaKey }: ScommesseTipoProps) => {
  const { tipoScommessaId } = useMemo(() => new KeyManagerSport(scommessaKey), [scommessaKey]);
  const infoTipoScommessa = useInfoTipo(tipoScommessaId);
  const { showHeader } = useInfoAggiuntivaBilanciata(scommessaKey);

  return (
    <React.Fragment key={scommessaKey}>
      {calculateBoxNumber(infoTipoScommessa, esitoTrKey).map(({ header, headerTrKey, size }, index) => (
        <ScommesseEsitoSkeleton
          key={`${header}_${index}`}
          size={index === 0 ? size : undefined}
          testId={headerTrKey}
          header={showHeader ? header : undefined}
          headerTrKey={headerTrKey}
        />
      ))}
    </React.Fragment>
  );
};
